import { Outlet } from "react-router-dom";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-ra-ink">
      <Nav />
      <AnnouncementBanner />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
